export const PROCESSING_STATUS_OPTIONS = [
  { label: 'Pendente aprovação', value: 'PENDING_APPROVAL' },
  { label: 'Aprovado', value: 'APPROVED' },
  { label: 'Recusado', value: 'REJECTED' },
  { label: 'Comunicação enviada', value: 'COMMUNICATION_SENT' },
  { label: 'Finalizado', value: 'FINISHED' },
] as const;

export const STATUS_SOLFACIL_OPTIONS = [
  { label: 'Regular', value: 'REGULAR' },
  { label: 'Bloqueado', value: 'BLOCKED' },
] as const;

export const TABLE_COLUMNS = [
  { name: 'Account Key', sort: true, value: 'account_key' },
  { name: 'ID do parceiro', sort: true, value: 'partner_id' },
  { name: 'CNPJ', sort: true, value: 'partner_cnpj' },
  { name: 'Nome', sort: true, value: 'partner_name' },
  { name: 'Email', sort: true, value: 'partner_email' },
  { name: 'Status Processamento', sort: true, value: 'processing_status' },
  { name: 'Telefone', sort: true, value: 'partner_phone' },
  { name: 'Status Solfácil', sort: true, value: 'status_solfacil' },
  { name: 'Inserido em', sort: true, value: 'inserted_at' },
  { name: 'Atualizado em', sort: true, value: 'updated_at' },
  { name: 'Email Aprovador', sort: true, value: 'approver_email' },
  { name: 'Última Simulação', sort: true, value: 'last_simulation_date' },
  { name: 'Última Transferência', sort: true, value: 'last_transfer_date' },
  { name: 'Mês Competência', sort: true, value: 'competency_month' },
] as const;
